// Типы исполнительных схем
export class CdExecutiveSchemeTypes {
  // Геодезическая
  public static GeodeticSchemeType: guid = '0f8d8698-cabc-47d9-9a3a-0e8e75f32e96';
  // Негеодезическая
  public static NonGeodeticSchemeType : guid = 'eabd83d9-10cb-4fb0-af64-2c9fe604e372';  
}